<template>
    <div class="login" :class="{ 'authenticating': isClickedAccessed }">
        <!-- Background com gradiente animado -->
        <div class="login_background">
            <div class="login_background_gradient"></div>
            <div class="login_background_shapes">
                <div class="login_background_shape login_background_shape1"></div>
                <div class="login_background_shape login_background_shape2"></div>
                <div class="login_background_shape login_background_shape3"></div>
            </div>
        </div>

        <!-- Container principal centralizado -->
        <div class="login_container">
            <div class="login_card">
                <!-- Logo/Brand -->
                <div class="login_card_header">
                    <div class="login_card_logo">
                        <div class="login_card_logoIcon">
                            <sw-icon name="shield" />
                        </div>
                        <h2 class="login_card_logoText">FileSave</h2>
                    </div>
                    
                    <!-- Tabs -->
                    <div class="login_tabs">
                        <button 
                            :class="['login_tab', { 'active': activeTab === 'login' }]"
                            @click="switchTab('login')"
                        >
                            Entrar
                        </button>
                        <button 
                            :class="['login_tab', { 'active': activeTab === 'register' }]"
                            @click="switchTab('register')"
                        >
                            Criar Conta
                        </button>
                    </div>
                    
                    <div class="login_card_welcome">
                        <h1 class="login_card_title">
                            {{ activeTab === 'login' ? 'Bem-vindo!' : 'Crie sua conta' }}
                        </h1>
                        <p class="login_card_subtitle">
                            {{ activeTab === 'login' ? 'Acesse sua conta para continuar' : 'Comece a organizar seus arquivos' }}
                        </p>
                    </div>
                </div>

                <!-- Formulário de Login -->
                <form v-if="activeTab === 'login'" class="login_form login_form--animated" @submit.prevent="authenticate">
                    <div class="login_form_group">
                        <sw-input 
                            v-model="user.email" 
                            type="email"
                            label="E-mail"
                            placeholder="seu@email.com"
                            icon="mail"
                            size="1.1"
                            :disabled="isClickedAccessed"
                            :validation="validations.email"
                            @blur="validateField('email')"
                        />
                    </div>

                    <div class="login_form_group">
                        <sw-input 
                            v-model="user.password" 
                            type="password"
                            label="Senha"
                            placeholder="Digite sua senha"
                            icon="lock"
                            size="1.1"
                            :disabled="isClickedAccessed"
                            :validation="validations.password"
                            @blur="validateField('password')"
                        />
                    </div>

                    <div class="login_form_options">
                        <sw-checkbox 
                            v-model="user.saveAutentication"
                            :disabled="isClickedAccessed"
                            label="Manter conectado"
                        />
                    </div>

                    <div class="login_form_actions">
                        <sw-button 
                            v-if="!isClickedAccessed"
                            type="submit"
                            name="Entrar"
                            color="blue"
                            size="lg"
                        />
                        <div v-if="isClickedAccessed" class="login_loading_indicator">
                            <div class="loading_spinner"></div>
                            <span>Verificando suas credenciais...</span>
                        </div>
                    </div>

                    <div class="login_form_forgot">
                        <a href="#" @click.prevent="showForgotPassword" class="login_form_forgotPassword">
                            Esqueci minha senha
                        </a>
                    </div>
                </form>

                <!-- Formulário de Registro -->
                <form v-if="activeTab === 'register'" class="login_form login_form--animated" @submit.prevent="registerUser">
                    <div class="login_form_group">
                        <sw-input 
                            v-model="newUser.name" 
                            type="text"
                            label="Nome Completo"
                            placeholder="Seu nome completo"
                            icon="user"
                            size="1.1"
                            :disabled="isClickedAccessed"
                            :validation="registerValidations.name"
                            @blur="validateRegisterField('name')"
                        />
                    </div>

                    <div class="login_form_group">
                        <sw-input 
                            v-model="newUser.email" 
                            type="email"
                            label="E-mail"
                            placeholder="seu@email.com"
                            icon="mail"
                            size="1.1"
                            :disabled="isClickedAccessed"
                            :validation="registerValidations.email"
                            @blur="validateRegisterField('email')"
                        />
                    </div>

                    <div class="login_form_group">
                        <sw-input 
                            v-model="newUser.password" 
                            type="password"
                            label="Senha"
                            placeholder="Mínimo 8 caracteres"
                            icon="lock"
                            size="1.1"
                            :disabled="isClickedAccessed"
                            :validation="registerValidations.password"
                            @blur="validateRegisterField('password')"
                        />
                    </div>

                    <div class="login_form_group">
                        <sw-input 
                            v-model="newUser.confirmPassword" 
                            type="password"
                            label="Confirmar Senha"
                            placeholder="Digite a senha novamente"
                            icon="lock"
                            size="1.1"
                            :disabled="isClickedAccessed"
                            :validation="registerValidations.confirmPassword"
                            @blur="validateRegisterField('confirmPassword')"
                        />
                    </div>


                    <div class="login_form_actions">
                        <sw-button 
                            v-if="!isClickedAccessed"
                            type="submit"
                            name="Criar Conta"
                            color="blue"
                            size="lg"
                        />
                        <div v-if="isClickedAccessed" class="login_loading_indicator">
                            <div class="loading_spinner"></div>
                            <span>Criando sua conta...</span>
                        </div>
                    </div>
                </form>

                <!-- Footer -->
                <div class="login_card_footer">
                    <div class="login_card_help">
                        <p>Problemas para acessar?</p>
                        <a href="#" class="login_card_helpLink">
                            <sw-icon name="mail" />
                            Fale com o suporte
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Esqueci Senha -->
        <transition name="modal">
            <div v-if="showForgotModal" class="modal_overlay" @click.self="closeForgotPassword">
                <div class="modal_card forgot_password_modal">
                    <div class="modal_header">
                        <h3>Recuperar Senha</h3>
                        <button @click="closeForgotPassword" class="modal_close">
                            <sw-icon name="x" />
                        </button>
                    </div>
                    
                    <div class="modal_body">
                        <p>Digite seu e-mail cadastrado para receber as instruções de recuperação de senha.</p>
                        
                        <div class="login_form_group">
                            <sw-input 
                                v-model="forgotEmail" 
                                type="email"
                                label="E-mail"
                                placeholder="seu@email.com"
                                icon="mail"
                                size="1.1"
                                :disabled="isSendingRecovery"
                                :validation="forgotEmailValidation"
                                @blur="validateForgotEmail"
                            />
                        </div>
                    </div>
                    
                    <div class="modal_footer">
                        <sw-button 
                            @click="closeForgotPassword"
                            name="Cancelar"
                            color="gray"
                            size="md"
                            :disabled="isSendingRecovery"
                        />
                        <sw-button 
                            @click="sendPasswordRecovery"
                            :name="isSendingRecovery ? 'Enviando...' : 'Enviar E-mail'"
                            color="blue"
                            size="md"
                            :disabled="isSendingRecovery"
                        />
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script setup>
    import { ref } from 'vue';
    import { useStore } from 'vuex';
    import { useRouter } from 'vue-router';

    import { notify, clearAllNotify, validation } from 'sysweb-vue-components/src/global';

    const store = useStore();
    const router = useRouter();

    // Estados do formulário
    const activeTab = ref('login'); // 'login' ou 'register'

    const user = ref({
        email: '',
        password: '',
        saveAutentication: false
    });

    const newUser = ref({
        name: '',
        email: '',
        password: '',
        confirmPassword: ''
    });

    const isClickedAccessed = ref(false);

    // Validação usando padrão sysweb-vue-components
    const validations = ref({
        email: { isValid: true, error: { message: '' } },
        password: { isValid: true, error: { message: '' } }
    });

    const registerValidations = ref({
        name: { isValid: true, error: { message: '' } },
        email: { isValid: true, error: { message: '' } },
        password: { isValid: true, error: { message: '' } },
        confirmPassword: { isValid: true, error: { message: '' } }
    });

    // Forgot Password Modal
    const showForgotModal = ref(false);
    const forgotEmail = ref('');
    const forgotEmailValidation = ref({ isValid: true, error: { message: '' } });
    const isSendingRecovery = ref(false);

    // Função para trocar tabs
    const switchTab = (tab) => {
        if (tab !== activeTab.value) {
            activeTab.value = tab;
        }
    };

    // Funções de validação usando sysweb-vue-components
    const validateField = (fieldName) => {
        const value = user.value[fieldName];

        switch (fieldName) {
            case 'email':
                if (!value || !value.trim()) {
                    validations.value.email = {
                        isValid: false,
                        error: { message: 'E-mail é obrigatório' }
                    };
                } else if (!validation.isEmail(value)) {
                    validations.value.email = {
                        isValid: false,
                        error: { message: 'Formato de e-mail inválido' }
                    };
                } else {
                    validations.value.email = { isValid: true, error: { message: '' } };
                }
                break;

            case 'password':
                if (!value || !value.trim()) {
                    validations.value.password = {
                        isValid: false,
                        error: { message: 'Senha é obrigatória' }
                    };
                } else if (!validation.isLength(value, { min: 8 })) {
                    validations.value.password = {
                        isValid: false,
                        error: { message: 'Senha deve ter pelo menos 8 caracteres' }
                    };
                } else {
                    validations.value.password = { isValid: true, error: { message: '' } };
                }
                break;
        }
    };

    const validateAllFields = () => {
        validateField('email');
        validateField('password');

        return validations.value.email.isValid && validations.value.password.isValid;
    };

    // Funções de validação para registro
    const validateRegisterField = (fieldName) => {
        const value = newUser.value[fieldName];

        switch (fieldName) {
            case 'name':
                if (!value || !value.trim()) {
                    registerValidations.value.name = {
                        isValid: false,
                        error: { message: 'Nome é obrigatório' }
                    };
                } else if (!validation.isLength(value.trim(), { min: 2 })) {
                    registerValidations.value.name = {
                        isValid: false,
                        error: { message: 'Nome deve ter pelo menos 2 caracteres' }
                    };
                } else {
                    registerValidations.value.name = { isValid: true, error: { message: '' } };
                }
                break;

            case 'email':
                if (!value || !value.trim()) {
                    registerValidations.value.email = {
                        isValid: false,
                        error: { message: 'E-mail é obrigatório' }
                    };
                } else if (!validation.isEmail(value)) {
                    registerValidations.value.email = {
                        isValid: false,
                        error: { message: 'Formato de e-mail inválido' }
                    };
                } else {
                    registerValidations.value.email = { isValid: true, error: { message: '' } };
                }
                break;

            case 'password':
                if (!value || !value.trim()) {
                    registerValidations.value.password = {
                        isValid: false,
                        error: { message: 'Senha é obrigatória' }
                    };
                } else if (!validation.isLength(value, { min: 8 })) {
                    registerValidations.value.password = {
                        isValid: false,
                        error: { message: 'Senha deve ter pelo menos 8 caracteres' }
                    };
                } else {
                    registerValidations.value.password = { isValid: true, error: { message: '' } };
                }
                break;

            case 'confirmPassword':
                if (!value || !value.trim()) {
                    registerValidations.value.confirmPassword = {
                        isValid: false,
                        error: { message: 'Confirmação de senha é obrigatória' }
                    };
                } else if (value !== newUser.value.password) {
                    registerValidations.value.confirmPassword = {
                        isValid: false,
                        error: { message: 'Senhas não coincidem' }
                    };
                } else {
                    registerValidations.value.confirmPassword = { isValid: true, error: { message: '' } };
                }
                break;
        }
    };

    const validateAllRegisterFields = () => {
        validateRegisterField('name');
        validateRegisterField('email');
        validateRegisterField('password');
        validateRegisterField('confirmPassword');

        return Object.values(registerValidations.value).every(field => field.isValid);
    };


    const authenticate = async () => {
        if (isClickedAccessed.value) return;

        // Validar campos antes de prosseguir
        if (!validateAllFields()) {
            if (!validations.value.email.isValid) {
                notify(validations.value.email.error.message, 'error');
            } else if (!validations.value.password.isValid) {
                notify(validations.value.password.error.message, 'error');
            }
            return;
        }

        isClickedAccessed.value = true;
        clearAllNotify();
        notify('Verificando credenciais...', 'info');

        try {
            let response = await store.dispatch('auth/autheticate', {
                email: user.value.email,
                password: user.value.password,
                isSave: user.value.saveAutentication
            });

            if (response.status === 'success') {
                clearAllNotify();
                notify(response.message, 'success');

                setTimeout(() => {
                    router.push({ name: 'Dashboard' });
                }, 1000);
                return;
            }

            clearAllNotify();
            notify(response.message, 'error');
            isClickedAccessed.value = false;

        } catch (error) {
            clearAllNotify();
            notify('Erro interno do sistema. Tente novamente.', 'error');
            isClickedAccessed.value = false;
        }
    };

    // Função de registro de usuário
    const registerUser = async () => {
        if (isClickedAccessed.value) return;

        // Validar campos antes de prosseguir
        if (!validateAllRegisterFields()) {
            const firstInvalidField = Object.entries(registerValidations.value).find(([, validation]) => !validation.isValid);
            if (firstInvalidField) {
                notify(firstInvalidField[1].error.message, 'error');
            }
            return;
        }

        isClickedAccessed.value = true;
        clearAllNotify();
        notify('Criando sua conta...', 'info');

        try {
            let response = await store.dispatch('auth/register', {
                name: newUser.value.name,
                email: newUser.value.email,
                password: newUser.value.password
            });

            if (response.status === 'success') {
                clearAllNotify();
                notify('Conta criada com sucesso! Redirecionando...', 'success');

                setTimeout(() => {
                    router.push({ name: 'Dashboard' });
                }, 1000);
                return;
            }

            clearAllNotify();
            notify(response.message, 'error');
            isClickedAccessed.value = false;

        } catch (error) {
            clearAllNotify();
            notify('Erro interno do sistema. Tente novamente.', 'error');
            isClickedAccessed.value = false;
        }
    };

    // Forgot Password Functions
    const validateForgotEmail = () => {
        if (!forgotEmail.value || !forgotEmail.value.trim()) {
            forgotEmailValidation.value = {
                isValid: false,
                error: { message: 'E-mail é obrigatório' }
            };
        } else if (!validation.isEmail(forgotEmail.value)) {
            forgotEmailValidation.value = {
                isValid: false,
                error: { message: 'Formato de e-mail inválido' }
            };
        } else {
            forgotEmailValidation.value = { isValid: true, error: { message: '' } };
        }
    };

    const showForgotPassword = () => {
        showForgotModal.value = true;
        forgotEmail.value = user.value.email || '';
        forgotEmailValidation.value = { isValid: true, error: { message: '' } };
    };

    const closeForgotPassword = () => {
        showForgotModal.value = false;
        forgotEmail.value = '';
        forgotEmailValidation.value = { isValid: true, error: { message: '' } };
        isSendingRecovery.value = false;
    };

    const sendPasswordRecovery = async () => {
        validateForgotEmail();

        if (!forgotEmailValidation.value.isValid) {
            notify(forgotEmailValidation.value.error.message, 'error');
            return;
        }

        isSendingRecovery.value = true;

        try {
            // Simular delay da API
            await new Promise(resolve => setTimeout(resolve, 2000));

            clearAllNotify();
            notify('E-mail de recuperação enviado com sucesso! Verifique sua caixa de entrada.', 'success');

            closeForgotPassword();

        } catch (error) {
            notify('Erro ao enviar e-mail. Tente novamente.', 'error');
        } finally {
            isSendingRecovery.value = false;
        }
    };
</script>

<style lang="scss">
/* Reset e base */
.login {
    position: relative;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    font-family: var(--fontFamilyPrimary);
    padding: 2em;
}

/* Background avançado com gradientes e animações */
.login_background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}

.login_background_gradient {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        135deg,
        var(--linkColor) 0%,
        var(--colorBlueDark100) 25%,
        var(--colorBlue) 50%,
        var(--colorBlueDark200) 75%,
        var(--linkColor) 100%
    );
    background-size: 400% 400%;
    animation: login_gradientMove 20s ease infinite;
}

@keyframes login_gradientMove {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
}

.login_background_shapes {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.login_background_shape {
    position: absolute;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
    backdrop-filter: blur(10px);
    animation: login_shapeFloat 30s ease-in-out infinite;

    &.login_background_shape1 {
        width: 20em;
        height: 20em;
        top: 10%;
        left: -5%;
        animation-delay: 0s;
    }

    &.login_background_shape2 {
        width: 15em;
        height: 15em;
        top: 70%;
        right: -5%;
        animation-delay: -7s;
    }

    &.login_background_shape3 {
        width: 25em;
        height: 25em;
        top: 40%;
        left: -10%;
        animation-delay: -14s;
    }
}

@keyframes login_shapeFloat {
    0%, 100% { transform: translate(0, 0) rotate(0deg); }
    25% { transform: translate(2em, -1em) rotate(90deg); }
    50% { transform: translate(-1em, 2em) rotate(180deg); }
    75% { transform: translate(-2em, -1em) rotate(270deg); }
}

/* Container principal centralizado */
.login_container {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 100vh;
}

/* Card de login centralizado - Versão Moderna */
.login_card {
    width: 100%;
    max-width: 34em; /* Aumentado de 26em para 34em */
    padding: 3.5em 3.5em 3em; /* Aumentado padding */
    background: rgba(255, 255, 255, 0.98);
    border-radius: 2em; /* Aumentado border-radius */
    box-shadow: 
        0 2.5em 5em rgba(0, 0, 0, 0.12),
        0 1em 2em rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(30px);
    border: 1px solid rgba(255, 255, 255, 0.4);
    animation: login_slideIn 1s ease-out;
    position: relative;
    overflow: hidden;
}

/* Efeito de brilho sutil no card */
.login_card::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, 
        transparent, 
        rgba(255, 255, 255, 0.2), 
        transparent
    );
    transition: left 0.8s ease;
}

.login_card:hover::before {
    left: 100%;
}

@keyframes login_slideIn {
    from {
        opacity: 0;
        transform: translateY(2em) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* Header com logo e textos de boas-vindas */
.login_card_header {
    text-align: center;
    margin-bottom: 2.5em;
}

.login_card_logo {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75em;
    margin-bottom: 2em;
}

.login_card_logoIcon {
    width: 3.5em;
    height: 3.5em;
    background: linear-gradient(135deg, var(--linkColor), var(--colorBlueDark100));
    border-radius: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5em;
    color: var(--textWhite);
    box-shadow: var(--boxShadowLarge);
}

.login_card_logoText {
    font-size: 2em;
    font-weight: 700;
    margin: 0;
    background: linear-gradient(135deg, var(--linkColor), var(--colorBlueDark100));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

/* Tabs Ultra Modernas */
.login_tabs {
    position: relative;
    display: flex;
    background: linear-gradient(145deg, 
        rgba(255, 255, 255, 0.15) 0%, 
        rgba(255, 255, 255, 0.05) 100%
    );
    backdrop-filter: blur(25px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 1.5em;
    padding: 0.75em;
    margin: 2.5em 0;
    gap: 0.75em;
    box-shadow: 
        0 15px 45px rgba(0, 0, 0, 0.08),
        0 8px 25px rgba(59, 130, 246, 0.1),
        inset 0 2px 0 rgba(255, 255, 255, 0.2),
        inset 0 -2px 0 rgba(0, 0, 0, 0.02);
    overflow: hidden;
}

/* Efeito de fundo animado mais intenso */
.login_tabs::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, 
        rgba(59, 130, 246, 0.15) 0%, 
        rgba(147, 51, 234, 0.15) 25%, 
        rgba(236, 72, 153, 0.15) 50%, 
        rgba(168, 85, 247, 0.15) 75%, 
        rgba(59, 130, 246, 0.15) 100%
    );
    background-size: 400% 400%;
    animation: gradientShift 8s ease infinite;
    border-radius: inherit;
    opacity: 0;
    transition: all 0.5s ease;
}

.login_tabs:hover::before {
    opacity: 1;
    animation-duration: 4s; /* Acelera no hover */
}

/* Efeito de brilho orbital */
.login_tabs::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: conic-gradient(
        transparent, 
        rgba(59, 130, 246, 0.1), 
        transparent, 
        rgba(147, 51, 234, 0.1), 
        transparent, 
        rgba(236, 72, 153, 0.1), 
        transparent
    );
    animation: orbitalGlow 15s linear infinite;
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.6s ease;
}

.login_tabs:hover::after {
    opacity: 0.3;
    animation-duration: 8s;
}

@keyframes gradientShift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
}

@keyframes orbitalGlow {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* Botões das tabs ultra modernos */
.login_tab {
    position: relative;
    flex: 1;
    background: none;
    border: none;
    padding: 1.25em 2em;
    border-radius: 1em;
    font-size: 1em;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.7);
    cursor: pointer;
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    font-family: var(--fontFamilyPrimary);
    z-index: 3;
    overflow: hidden;
    backdrop-filter: blur(10px);
    
    /* Efeito de shimmer */
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -120%;
        width: 120%;
        height: 100%;
        background: linear-gradient(90deg, 
            transparent 0%, 
            rgba(255, 255, 255, 0.3) 50%, 
            transparent 100%
        );
        transition: left 0.8s ease;
        border-radius: inherit;
    }
    
    &:hover:not(.active) {
        color: rgba(0, 0, 0, 0.8);
        background: linear-gradient(135deg, 
            rgba(59, 130, 246, 0.1) 0%, 
            rgba(37, 99, 235, 0.1) 100%
        );
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
    }
    
    &.active {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        color: #ffffff;
        font-weight: 600;
        box-shadow: 
            0 6px 20px rgba(59, 130, 246, 0.4),
            0 2px 8px rgba(0, 0, 0, 0.1),
            inset 0 1px 0 rgba(255, 255, 255, 0.2);
        transform: translateY(-1px);
        
        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(135deg, 
                rgba(255, 255, 255, 0.3) 0%, 
                rgba(255, 255, 255, 0.1) 50%,
                rgba(255, 255, 255, 0.05) 100%
            );
            border-radius: inherit;
            pointer-events: none;
        }
    }
}


.login_card_title {
    font-size: 2.25em;
    font-weight: 700;
    color: var(--textPrimary, #1a1a1a);
    margin-bottom: 0.5em;
    line-height: 1.1;
}

.login_card_subtitle {
    font-size: 1em;
    color: var(--textSecondary, #666);
    line-height: 1.4;
    margin: 0;
}

/* Formulário Moderno */
.login_form {
    position: relative;
    z-index: 2;
}

.login_form_group {
    margin-bottom: 2em; /* Aumentado espaçamento */
    position: relative;
}


/* Validação é gerenciada automaticamente pelo sysweb-vue-components */

/* Animações para formulários */
.login_form--animated {
    animation: formSlideIn 0.5s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
}

@keyframes formSlideIn {
    0% {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }
    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* Override para sw-input no login */
.login .sw-input {
    width: 100%;
    font-family: var(--fontFamilyPrimary) !important;
}

/* Opções modernas do formulário */
.login_form_options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2.5em; /* Aumentado */
    flex-wrap: wrap;
    gap: 1.5em;
    padding: 1.5em;
    background: rgba(248, 250, 252, 0.6);
    border-radius: 1.25em;
    border: 1px solid rgba(226, 232, 240, 0.8);
    backdrop-filter: blur(10px);
    position: relative;
    transition: all 0.3s ease;
}

.login_form_options:hover {
    background: rgba(248, 250, 252, 0.8);
    border-color: rgba(59, 130, 246, 0.2);
    box-shadow: 0 8px 25px rgba(59, 130, 246, 0.1);
}

.login_form_options::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: linear-gradient(135deg, 
        rgba(59, 130, 246, 0.05) 0%, 
        rgba(147, 51, 234, 0.05) 100%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
}

.login_form_options:hover::before {
    opacity: 1;
}


/* Link "Esqueci minha senha" modernizado */
.login_form_forgot {
    text-align: center;
    margin-bottom: 2em;
}

.login_form_forgotPassword {
    display: inline-flex;
    align-items: center;
    gap: 0.5em;
    font-size: 0.95em;
    color: var(--colorBlue, #3b82f6);
    text-decoration: none;
    font-weight: 600;
    padding: 0.75em 1.5em;
    border-radius: 0.75em;
    background: rgba(59, 130, 246, 0.08);
    border: 1px solid rgba(59, 130, 246, 0.15);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(135deg, 
            rgba(59, 130, 246, 0.1), 
            rgba(147, 51, 234, 0.1)
        );
        opacity: 0;
        transition: opacity 0.3s ease;
        border-radius: inherit;
    }

    &:hover {
        color: var(--colorBlueDark, #1d4ed8);
        background: rgba(59, 130, 246, 0.12);
        border-color: rgba(59, 130, 246, 0.25);
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(59, 130, 246, 0.15);
        
        &::before {
            opacity: 1;
        }
    }

    &:active {
        transform: translateY(-1px);
    }
}

/* Ações modernizadas do formulário */
.login_form_actions {
    margin-bottom: 2.5em;
    position: relative;
    
    .sw-button {
        width: 100%;
        font-family: var(--fontFamilyPrimary) !important;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        overflow: hidden;
        padding: 1.25em 2em; /* Aumentado padding */
        border-radius: 1em; /* Mais arredondado */
        font-weight: 600;
        font-size: 1.1em; /* Ligeiramente maior */
        box-shadow: 
            0 8px 25px rgba(59, 130, 246, 0.3),
            0 3px 12px rgba(0, 0, 0, 0.1);
        
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, 
                transparent, 
                rgba(255, 255, 255, 0.3), 
                transparent
            );
            transition: left 0.6s ease;
        }
        
        &:hover::before {
            left: 100%;
        }
        
        &:hover {
            transform: translateY(-3px);
            box-shadow: 
                0 12px 35px rgba(59, 130, 246, 0.4),
                0 5px 20px rgba(0, 0, 0, 0.15);
        }
        
        &.login_button_loading {
            animation: buttonPulse 2s infinite;
        }
    }
}

@keyframes buttonPulse {
    0%, 100% { 
        box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);
    }
    50% { 
        box-shadow: 0 4px 24px rgba(59, 130, 246, 0.5);
    }
}

/* Indicador de loading modernizado */
.login_loading_indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1em;
    width: 100%;
    padding: 1.25em 2em;
    color: var(--colorBlue, #3b82f6);
    font-size: 0.95em;
    background: rgba(59, 130, 246, 0.05);
    border-radius: 1em;
    border: 1px solid rgba(59, 130, 246, 0.1);
    animation: fadeIn 0.4s ease-out;
    
    span {
        font-weight: 600;
        background: linear-gradient(135deg, 
            var(--colorBlue, #3b82f6), 
            var(--colorBlueDark, #1d4ed8)
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
}

.loading_spinner {
    width: 20px;
    height: 20px;
    border: 2.5px solid rgba(59, 130, 246, 0.2);
    border-left: 2.5px solid var(--colorBlue, #3b82f6);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    position: relative;
}

.loading_spinner::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    border-radius: 50%;
    border: 1px solid rgba(59, 130, 246, 0.1);
}

@keyframes spin {
    0% { 
        transform: rotate(0deg); 
        box-shadow: 0 0 0 rgba(59, 130, 246, 0.4);
    }
    50% { 
        transform: rotate(180deg); 
        box-shadow: 0 0 10px rgba(59, 130, 246, 0.2);
    }
    100% { 
        transform: rotate(360deg); 
        box-shadow: 0 0 0 rgba(59, 130, 246, 0.4);
    }
}

/* Footer do card */
.login_card_footer {
    text-align: center;
}

.login_card_help p {
    margin: 0 0 0.75em 0;
    font-size: 0.875em;
    color: var(--textSecondary, #666);
}

.login_card_helpLink {
    display: inline-flex;
    align-items: center;
    gap: 0.5em;
    color: var(--colorBlue, #3b82f6);
    text-decoration: none;
    font-size: 0.875em;
    font-weight: 500;
    transition: all 0.2s ease;
    padding: 0.5em 1em;
    border-radius: 0.5em;
    background: rgba(59, 130, 246, 0.1);

    &:hover {
        color: var(--colorBlueDark, #1d4ed8);
        background: rgba(59, 130, 246, 0.15);
        transform: translateY(-1px);
    }
}

/* Responsividade para design moderno */
@media (max-width: 768px) {
    .login {
        padding: 1em;
    }
    
    .login_card {
        max-width: 100%;
        padding: 3em 2.5em; /* Mantém padding generoso em mobile */
        border-radius: 1.5em; /* Ligeiramente menor em mobile */
    }

    .login_card_title {
        font-size: 2em;
    }

    .login_card_logoIcon {
        width: 3em;
        height: 3em;
    }

    .login_card_logoText {
        font-size: 1.75em;
    }

    .login_form_options {
        flex-direction: column;
        align-items: stretch;
        gap: 1.25em;
        padding: 1.25em; /* Reduzido para mobile */
    }
    
    /* Tabs responsivas ultra modernas */
    .login_tabs {
        margin: 2em 0;
        padding: 0.5em;
        gap: 0.5em;
        border-radius: 1.25em;
        backdrop-filter: blur(20px);
    }
    
    .login_tab {
        padding: 1em 1.5em;
        font-size: 0.95em;
        border-radius: 0.875em;
        
        &.active {
            transform: translateY(-1px) scale(1.02);
            box-shadow: 
                0 8px 20px rgba(59, 130, 246, 0.2),
                0 4px 12px rgba(0, 0, 0, 0.06);
        }
        
        &:hover {
            transform: translateY(-1px) scale(1.01);
        }
    }
    
    /* Simplificar animações complexas em mobile */
    .login_tab.active::before,
    .login_tab.active::after,
    .login_tabs::before,
    .login_tabs::after,
    .login_card::before {
        display: none;
    }
    
    /* Manter apenas animações básicas em mobile */
    .login_tabs::before {
        display: block;
        animation: none;
        opacity: 0.5;
        background: linear-gradient(135deg, 
            rgba(59, 130, 246, 0.08) 0%, 
            rgba(147, 51, 234, 0.08) 100%
        );
    }
    
    /* Botões menores em mobile */
    .login_form_actions .sw-button {
        padding: 1.1em 1.5em;
        font-size: 1em;
    }
    
    /* Loading indicator menor */
    .login_loading_indicator {
        padding: 1em;
        margin-top: 1.25em;
    }
}

@media (max-width: 480px) {
    .login_card {
        padding: 2em 1.5em;
        margin: 0.5em;
    }

    .login_card_title {
        font-size: 1.75em;
    }
}

/* Estados de loading */
.login.loading {
    .login_card {
        opacity: 0.8;
        pointer-events: none;
    }
}

/* Micro animações */
.login .sw-input:focus-within {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(59, 130, 246, 0.15) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.login .sw-input {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.login .sw-button:not(:disabled):hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4) !important;
}

.login .sw-button:not(:disabled):active {
    transform: scale(0.98) translateY(0);
    transition: transform 0.1s ease;
}

/* sysweb-vue-components gerencia validação visual automaticamente */

/* Estados de loading global */
.login.authenticating {
    .login_card {
        position: relative;
        overflow: hidden;
    }
    
    .login_card::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 3px;
        background: linear-gradient(90deg, 
            transparent, 
            var(--colorBlue, #3b82f6), 
            transparent
        );
        animation: progressSlide 2s ease-in-out infinite;
        z-index: 10;
    }
}

@keyframes progressSlide {
    0% { left: -100%; }
    100% { left: 100%; }
}

/* Modal Styles */
.modal_overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(8px);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2em;
}

.modal_card {
    background: var(--backgroundCard, #fff);
    border-radius: 1.5em;
    box-shadow: 0 2em 4em rgba(0, 0, 0, 0.25);
    width: 100%;
    max-width: 480px;
    max-height: 90vh;
    overflow: hidden;
    animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
    from {
        opacity: 0;
        transform: translateY(-2em) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.modal_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2em 2em 1em;
    border-bottom: 1px solid var(--dashboardBorderColor, #e5e7eb);

    h3 {
        margin: 0;
        font-size: 1.5em;
        font-weight: 600;
        color: var(--textPrimary, #1a1a1a);
    }
}

.modal_close {
    background: none;
    border: none;
    color: var(--textMuted, #666);
    cursor: pointer;
    padding: 0.5em;
    border-radius: 0.5em;
    transition: var(--transitionDefault, all 0.2s ease);
    
    &:hover {
        background: var(--backgroundHover, #f3f4f6);
        color: var(--textPrimary, #1a1a1a);
    }
}

.modal_body {
    padding: 1.5em 2em;
    
    p {
        margin: 0 0 1.5em 0;
        color: var(--textSecondary, #666);
        line-height: 1.5;
    }
}

.modal_footer {
    display: flex;
    gap: 1em;
    padding: 1em 2em 2em;
    justify-content: flex-end;
    
    .sw-button {
        font-family: var(--fontFamilyPrimary) !important;
    }
}

/* Modal Transitions */
.modal-enter-active,
.modal-leave-active {
    transition: all 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
    backdrop-filter: blur(0px);
}

.modal-enter-from .modal_card,
.modal-leave-to .modal_card {
    transform: translateY(-2em) scale(0.95);
}

/* Responsividade para modal */
@media (max-width: 768px) {
    .modal_overlay {
        padding: 1em;
    }
    
    .modal_header {
        padding: 1.5em 1.5em 1em;
        
        h3 {
            font-size: 1.25em;
        }
    }
    
    .modal_body {
        padding: 1em 1.5em;
    }
    
    .modal_footer {
        padding: 1em 1.5em 1.5em;
        flex-direction: column;
        
        .sw-button {
            width: 100%;
        }
    }
}
</style>